import { render, staticRenderFns } from "./IranValidity.vue?vue&type=template&id=6615b6e8&scoped=true"
import script from "./IranValidity.vue?vue&type=script&lang=js"
export * from "./IranValidity.vue?vue&type=script&lang=js"
import style0 from "./IranValidity.vue?vue&type=style&index=0&id=6615b6e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6615b6e8",
  null
  
)

export default component.exports